<template>
  <div>
    <!-- Desktop: dual-pane, both panels always visible -->
    <div class="notable-layout" v-if="!isMobile">
      <div class="left-panel">
        <NotableIndividualTopHeader />
        <NotableIndividualView />
      </div>
      <div class="right-panel">
        <NotableIndividualDetail />
      </div>
    </div>

    <!-- Mobile: single-pane, list or detail -->
    <template v-else>
      <div v-if="!isOpenedDetail" class="notable-mobile">
        <NotableIndividualTopHeader />
        <NotableIndividualView />
      </div>
      <NotableIndividualDetail v-else />
    </template>
  </div>
</template>

<script>
import NotableIndividualsCalculateWatcher from './services/NotableIndividualsCalculateWatcher';
import NotableIndividualTopHeader from './NotableIndividualTopHeader.vue';
import NotableIndividualView from './pages/NotableIndividualView.vue';
import NotableIndividualDetail from './pages/NotableIndividualDetail.vue';

export default {
  components: {
    NotableIndividualTopHeader,
    NotableIndividualView,
    NotableIndividualDetail,
  },
  computed: {
    isMobile() {
      return this.$store.state.appConfig.windowWidth < 769;
    },
    isOpenedDetail() {
      return this.$store.state.ancientNotableIndividualResult.isOpenedDetail;
    },
    hasSelection() {
      return this.$store.state.ancientNotableIndividualResult.openedDetail.id > 0;
    },
  },
  mounted() {
    NotableIndividualsCalculateWatcher.init();
    if (this.$store.state.appConfig.windowWidth < 769) {
      document.body.classList.add('fixed-scroll-iframe');
    }
  },
  beforeDestroy() {
    if (this.$store.state.appConfig.windowWidth < 769) {
      document.body.classList.remove('fixed-scroll-iframe');
    }
  },
};
</script>

<style lang="scss" scoped>
.notable-layout {
  display: flex;
  height: 100vh;

  .left-panel {
    width: 40%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    height: 100vh;
    border-right: 1px solid var(--border-color, #dee2e6);
  }

  .right-panel {
    flex: 1;
    height: 100vh;
    overflow-y: auto;
    background-color: var(--white-100);
  }
}

.notable-mobile {
  height: 100vh;
  overflow-x: hidden;
}

.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 2rem;
  color: var(--black-40);
  text-align: center;
  font-size: 0.95rem;
}
</style>
